import Editor from '@monaco-editor/react'
import type { OnMount } from '@monaco-editor/react'
import type * as monaco from 'monaco-editor'

interface YamlMonacoEditorProps {
  value: string
  onChange: (value: string) => void
  editorRef: React.MutableRefObject<monaco.editor.IStandaloneCodeEditor | null>
  readOnly?: boolean
}

export function YamlMonacoEditor({ value, onChange, editorRef, readOnly = false }: YamlMonacoEditorProps) {
  const handleEditorDidMount: OnMount = (editor) => {
    editorRef.current = editor
  }

  return (
    <div className="h-full" data-testid="yaml-editor">
      <Editor
        height="100%"
        language="yaml"
        theme="vs-dark"
        value={value}
        onChange={(val) => onChange(val ?? '')}
        onMount={handleEditorDidMount}
        options={{
          readOnly,
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: 'on',
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          tabSize: 2,
          renderLineHighlight: 'line',
          folding: true,
          bracketPairColorization: { enabled: true },
        }}
      />
    </div>
  )
}
